'use client'
import React, { ReactElement, useState } from 'react'
import HeaderCopyright from '@/components/headers/HeaderCopyright'
import Divider from '@/components/Divider'
import Navigation from '@/components/navigation/Navigation'

const NotYetAiDao = (): ReactElement => {
    const [leftOpen, setLeftOpen] = useState(false)

    return (
        <React.Fragment>
            <HeaderCopyright />
            <div className="main-container">
                <Navigation />
                <Divider />
                <h1 className={'white centered-row'}>NOT YET IMPLEMENTED</h1>
                <div className="centered-text gray">
                    Taking the DAO to the next level with AI.
                    <br />
                    Imagine a DAO controlled by a customized ChatGPT that has been fed with Atropa data.
                    <br />
                    This AI can suggest (and execute) actions to increase the CRAZY token value. Let the community vote
                    on the best ones.
                </div>
            </div>
        </React.Fragment>
    )
}

export default NotYetAiDao
